<template>
  <div>
    <form class="pt-4 pb-4">
      <div class="form-group">
        <label>Student number</label>
        <div class="text">{{ student.studentNumber }}</div>
      </div>
      <div class="form-group">
        <label>Old Student number</label>
        <div class="text">{{ student.oldStudentNumber }}</div>
      </div>
      <div class="form-group">
        <label>Student name</label>
        <div class="text">{{ student.nameJp }}</div>
      </div>
      <div class="form-group">
        <label>Student name (Alphabet)</label>
        <div class="text">{{ student.name }}</div>
      </div>
      <div class="form-group">
        <label>Nickname</label>
        <div class="text">{{ student.nickname }}</div>
      </div>
      <div class="form-group">
        <label>Student status</label>
        <div class="text">{{ student.studentStatus | status }}</div>
      </div>
      <b-row>
        <b-col>
          <div class="form-group">
            <label>Email1</label>
            <div class="text">{{ student.email1 }}</div>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label>Email2</label>
            <div class="text">{{ student.email2 }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label>Contact1</label>
            <div class="text">{{ student.phone1 }}</div>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label>Contact2</label>
            <div class="text">{{ student.phone2 }}</div>
          </div>
        </b-col>
      </b-row>
    </form>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="student.courseHistories"
      :fields="fields"
      :table-class="'list-table text-center mb-5'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import {
  Student,
  SpecialConsideration,
  StudentStatus,
  studentStatusCode,
} from '@/store/students/types';

@Component({
  filters: {
    status: (s: studentStatusCode): string => StudentStatus[s],
  },
})
export default class StudentConfirmForm extends Vue {
  @Prop() student!: Student

  private fields: Array<{key: string, label: string, formatter?: Function}> = [
    {
      key: 'no',
      label: 'No',
    },
    {
      key: 'courseName',
      label: 'Course',
    },
    {
      key: 'specialConsiderations',
      label: 'Special consideration',
      formatter: (specialConsiderations: SpecialConsideration[]): string => {
        return specialConsiderations?.map((specialConsideration: SpecialConsideration) => {
          return specialConsideration.specialConsideration?.name;
        }).join(' , ')
      },
    },
  ]
}
</script>

<style scoped>
.text {
  font-size: 18px;
}
</style>
